import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { each } from 'lodash';
import Fa from 'react-fontawesome';

import styles from './opportunity-graphs.css';
import { getColorFromKey } from '../../../../util/helpers';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';

function legend(props) {
  const { bucket, reportType, hasNoDecisionSetup } = props;
  const rows = [];
  each(bucket.stats, (stat, key) => {
    let { unit } = stat;
    if (!unit) {
      if (key === 'won') {
        unit = 'Win';
      } else if (key === 'lost') {
        unit = 'Loss';
      } else if (key === 'noDecision') {
        unit = 'No Decision';
      }
    }
    
    const color = getColorFromKey(key);
    const countPercentage = bucket.total !== 0 ? (stat.total / bucket.total) * 100 : 0;
    const amountPercentage = bucket.amount !== 0 ? (stat.amount / bucket.amount) * 100 : 0;
    const percentage = (reportType === 'amount' ? amountPercentage : countPercentage);

    if ((key === 'noDecision' && hasNoDecisionSetup) || (key !== 'noDecision')) {
      rows.push((
        <tr key={key}>
          <td width="10" className="text-center" style={{ color }}><Fa name="circle" /></td>
          <td>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onChartSegmentSelect(stat.opportunityIds);
              }}
            >
              <strong><NumberDisplay value={stat.total} precision={0} suffix={unit} suffixIsUnit /></strong>
            </a>
          </td>
          <td className="text-right"><nobr><MoneyDisplay abbreviated value={stat.amount} precision={1} /></nobr></td>
          <td className="text-right"><NumberDisplay value={percentage} suffix="%" /></td>
        </tr>
      ));
    }
  });
  return (
    <div className={styles.legend}>
      <table className="table table-bordered table-condensed">
        <tbody>
          {rows}
        </tbody>
        <tfoot>
          <tr>
            <td width="10" className="text-center" />
            <td>
              <strong>
                <NumberDisplay value={bucket.total} precision={0} /> <span>{pluralize('Deal', bucket.total)}</span>
              </strong>
            </td>
            <td className="text-right"><nobr><MoneyDisplay abbreviated value={bucket.amount} precision={1} /></nobr></td>
            <td className="text-right"><NumberDisplay value={100} suffix="%" /></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

legend.propTypes = {
  bucket: PropTypes.shape({
    total: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  reportType: PropTypes.string.isRequired,
};
export default legend;
